import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { Category } from 'src/app/stores/stores';

@Component({
  selector: 'app-horizontal-category-nav',
  templateUrl: './horizontal-category-nav.component.html',
  styleUrls: ['./horizontal-category-nav.component.scss'],
})
export class HorizontalCategoryNavComponent implements OnInit, AfterViewInit {
  @Input() menuCategories: Category[] = [];
  @Input() selectedCat: number;
  @Input() wrapperId: string = 'nav-tab-wrapper';
  @Input() showCondition: boolean = true;

  @Output() categorySelected = new EventEmitter<number>();

  @ViewChild('navTabContainer', { static: false }) navTabContainer: ElementRef;

  navMaxLeftScroll: { [key: string]: boolean } = {};
  navMaxRightScroll: { [key: string]: boolean } = {};

  constructor() {}

  ngOnInit(): void {
    // Initialize scroll state
    this.navMaxLeftScroll[this.wrapperId] = true;
    this.navMaxRightScroll[this.wrapperId] = false;
  }

  ngAfterViewInit(): void {
    // Update scroll state after view initialization
    setTimeout(() => {
      this.updateScrollState(this.wrapperId);
    }, 100);
  }

  onSelectCategory(categoryId: number) {
    this.categorySelected.emit(categoryId);
  }

  scrollNavToLeft(wrapperId: string) {
    const wrapper = document.getElementById(wrapperId);
    if (wrapper) {
      wrapper.scrollLeft -= 200;
      this.updateScrollState(wrapperId);
    }
  }

  scrollNavToRight(wrapperId: string) {
    const wrapper = document.getElementById(wrapperId);
    if (wrapper) {
      wrapper.scrollLeft += 200;
      this.updateScrollState(wrapperId);
    }
  }

  private updateScrollState(wrapperId: string) {
    const wrapper = document.getElementById(wrapperId);
    if (wrapper) {
      this.navMaxLeftScroll[wrapperId] = wrapper.scrollLeft <= 0;
      this.navMaxRightScroll[wrapperId] =
        wrapper.scrollLeft >= wrapper.scrollWidth - wrapper.clientWidth;
    }
  }
}
